// extracted by mini-css-extract-plugin
module.exports = {"integrationsPage":"SalesChannels_integrationsPage__1m8Yo","integrationCardsContainer":"SalesChannels_integrationCardsContainer__16N7O"};